import React, { useState } from 'react';
import {
  Grid,
  FormControl,
  FormControlLabel,
  FormHelperText,
  TextField,
  Box,
  Button,
  Checkbox,
} from '@material-ui/core';

import { useGetSignedUrl } from 'api/membership-perks';
import useSignedPostUploader from 'dataLayer/use-signed-post-uploader';

export function UploadFile({ onChange, name, value, title, buttonText }) {
  const [ext, setExt] = useState(null);
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(null);
  const [error, setError] = useState(null);
  //TODO handle Progress and Error
  const { uploadFile } = useSignedPostUploader({ setProgress, setError });

  useGetSignedUrl({
    filename: file?.name, //this allows for a new query if user changes their mind.
    ext,
    options: {
      onSuccess: signedPost => {
        uploadFile({ signedPost, file });
        //This sends the url s3 key to the BE. The BE handles the coludinary portion
        onChange({ target: { name, value: signedPost?.fields?.key } });
      },
    },
  });

  async function onFileSelected({ target }) {
    const file = target.files[0];
    setFile(file);
    const { name } = file;
    const extensionData = name.split('.');
    const newExt = (extensionData[extensionData.length - 1] || '').toLowerCase();
    setExt(newExt);
  }

  return (
    <Grid>
      <FormHelperText>{title || titlefy(name)}</FormHelperText>
      <Box margin={'10px'}>
        <input
          onChange={onFileSelected}
          accept="image/*"
          style={{ display: 'none' }}
          id="raised-button-file"
          type="file"
        />
        <label htmlFor="raised-button-file">
          <Button variant="outlined" component="span">
            {buttonText}
          </Button>
        </label>
        {value || file ? <img src={file ? URL.createObjectURL(file) : value} width="150px" /> : null}
      </Box>
    </Grid>
  );
}
export function CheckboxInput({ name, value = [], title, options, onChange }) {
  const [checked, setChecked] = useState(value || []);
  function updateChecked({ target }) {
    const newValue = target.checked ? [...checked, target.name] : checked.filter(c => c !== target.name);
    setChecked(newValue);
    onChange({ target: { name, value: newValue } });
  }

  return (
    <Grid item xs={8}>
      <Box margin={'10px'}>
        <FormHelperText>{title || titlefy(name)}</FormHelperText>
        {options.map(option => (
          <FormControlLabel
            key={option}
            onChange={updateChecked}
            name={option}
            control={<Checkbox checked={value.includes(option)} />}
            label={titlefy(option)}
          />
        ))}
      </Box>
    </Grid>
  );
}

export function Input({ name, minRows, onChange, value, title }) {
  return (
    <Grid item xs={8}>
      <Box margin={'10px'}>
        <FormControl fullWidth={true}>
          <FormHelperText>{title || titlefy(name)}</FormHelperText>
          <TextField
            onChange={onChange}
            value={value || ''}
            name={name}
            minRows={minRows}
            multiline={minRows ? true : false}
          />
        </FormControl>
      </Box>
    </Grid>
  );
}

export const titlefy = word =>
  word
    .toLowerCase()
    .split('_')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
